import React, {useContext} from "react";
import Passenger from "./TravelPassenger";
import { AppContext } from "../../App";


export default function Travel(){

  const { eventDetails } = useContext(AppContext)

  return(
    <div className="event-details">
      <h3 className="section-title">
        Travel Details
      </h3>
      <h6 className="passenger-header">Passengers</h6>
      {eventDetails.travel.map((member)=> {
        return <Passenger 
            name={member.passengerName}
            dob={member.passengerDob}
            id={member.passengerId}
            email={member.passengerEmail}
            phone={member.passengerPhone}
            role={member.passengerRole}
            departRoute={member.departRoute}
            departDate={member.departDate}
            returnRoute={member.returnRoute}
            returnDate={member.returnDate}
            prefTime={member.prefTime}
            groundTravel={member.groundTravel}
            accom={member.accom}
            disabled={member.departRoute === "" && member.groundTravel === "" && member.accom === ""}
            />
      })}
    </div>
  )
}